/** Prefer API body.message; fall back to Error.message / default. */
export function getSalesApiErrorMessage(err: unknown, fallback: string): string {
  const bodyMessage = (err as { body?: { message?: string | string[] } })?.body?.message;
  const fromBody = Array.isArray(bodyMessage) ? bodyMessage[0] : bodyMessage;
  if (fromBody != null && fromBody !== '') {
    return fromBody;
  }
  return err instanceof Error ? err.message : fallback;
}
